import { useApiTradeV1SiteMaterialsRetrieve } from 'api';
import { ActionRow, Grid } from 'ui';

import { SiteMaterialCompanyLink } from '../../../site-material';

export const SiteMaterialQualityReportFooter = ({ siteMaterialId }: { siteMaterialId: string }) => {
  const { data: siteMaterial } = useApiTradeV1SiteMaterialsRetrieve(siteMaterialId);

  return (
    <Grid item xs={12} padding={2} bgcolor="white">
      <ActionRow>
        <SiteMaterialCompanyLink
          tradeCompanyId={Number(siteMaterial?.site.trade_company.id)}
          siteMaterialId={siteMaterialId}
        >
          Back to site quality page
        </SiteMaterialCompanyLink>
      </ActionRow>
    </Grid>
  );
};
